/**
 * Longest a click handler holds back a navigation for its tracking request.
 * WebKit cancels in-flight requests when the page is replaced, so a request
 * started right before `location.assign` can be lost on iOS Safari.
 */
export const MAX_TRACKING_WAIT_MS = 300;

/**
 * Resolves once `tracking` settles or after `maxWaitMs`, whichever is first.
 * Never rejects: a failed or slow tracking request must not block the player.
 */
export const waitForTracking = (
  tracking?: unknown,
  maxWaitMs: number = MAX_TRACKING_WAIT_MS
): Promise<void> => {
  if (!isPromiseLike(tracking)) return Promise.resolve();

  return new Promise<void>((resolve) => {
    const timer = setTimeout(resolve, maxWaitMs);
    const finish = () => {
      clearTimeout(timer);
      resolve();
    };

    tracking.then(finish, finish);
  });
};

const isPromiseLike = (value: unknown): value is PromiseLike<unknown> =>
  typeof (value as PromiseLike<unknown> | undefined)?.then === 'function';
